var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3001 13.5171L10.2881 3.10337C10.0226 2.64287 9.53062 2.35938 8.99962 2.35938C8.46862 2.35938 7.97662 2.64287 7.71112 3.10337L1.69912 13.5171C1.43363 13.9776 1.43363 14.5439 1.69912 15.0051C1.96462 15.4649 2.45587 15.7484 2.98762 15.7484H15.0124C15.5434 15.7484 16.0354 15.4649 16.3009 15.0044C16.5664 14.5439 16.5664 13.9776 16.3001 13.5171Z",
    fill: "#E85048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.88471 13.3114C9.88471 13.5762 9.73096 14.2519 8.99596 14.2519C8.26096 14.2519 8.11621 13.5754 8.11621 13.3114C8.11621 13.0527 8.27971 12.3597 8.99596 12.3597C9.71221 12.3597 9.88471 13.0527 9.88471 13.3114ZM8.18971 10.4412V7.17794C8.18971 6.73019 8.55271 6.36719 9.00046 6.36719C9.44821 6.36719 9.81121 6.73019 9.81121 7.17794V10.4419C9.81121 10.8889 9.44821 11.2519 9.00046 11.2519C8.55271 11.2519 8.18971 10.8889 8.18971 10.4412Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4b809d33e745f2becc94b06b55f8d2f9.svg";
export { ForwardRef as ReactComponent };